import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { useSave } from './Context/saveContext'
import { PERMISSION_CODES } from './constants/permissions'
import { useIsAuthenticated, useMsalAuthentication } from '@azure/msal-react'

export const RouteHandler = () => {
  const { userPermissions, isLoading } = useSave()
  const isAuthenticated = useIsAuthenticated()
  const editListPermission = userPermissions.includes(PERMISSION_CODES.viewEditLists.code)
  const editRolesPermission = userPermissions.includes(PERMISSION_CODES.viewCreateEditRoles.code)
  const assignRolesPermission = userPermissions.includes(PERMISSION_CODES.assignRoles.code)
  const viewMyTeamPagePermission = userPermissions.includes(PERMISSION_CODES.viewMyTeamPage.code)

  useMsalAuthentication('redirect')

  return (
    <RouterProvider
      router={router({
        isLoading,
        editListPermission,
        editRolesPermission,
        assignRolesPermission,
        isAuthenticated,
        viewMyTeamPagePermission
      })}
    />
  )
}
